export const categories = [
  { key: 'all', name: '全部', icon: 'ri-list-check-2' },
  { key: 'star', name: '明星娱乐', icon: 'ri-star-smile-fill' },
  { key: 'variety', name: '综艺现场', icon: 'ri-camera-fill' },
  { key: 'business', name: '商业财经', icon: 'ri-line-chart-fill' },
  { key: 'society', name: '社会民生', icon: 'ri-earth-fill' },
  { key: 'streamer', name: '直播网红', icon: 'ri-live-fill' },
];

export const hotEvents = [
  {
    id: 1,
    rank: 1,
    title: '顶流演员被曝合约纠纷，背后牵扯多方资本',
    category: 'star',
    heat: '984万',
    trend: 'up',
    tag: '持续发酵',
    time: '今日 09:12',
  },
  {
    id: 2,
    rank: 2,
    title: '某选秀综艺选手深夜发声，回应舞台争议',
    category: 'variety',
    heat: '762万',
    trend: 'up',
    tag: '新瓜速报',
    time: '今日 07:48',
  },
  {
    id: 3,
    rank: 3,
    title: '头部主播带货翻车？质量风波引全网热议',
    category: 'streamer',
    heat: '651万',
    trend: 'flat',
    tag: '持续发酵',
    time: '昨日 22:30',
  },
  {
    id: 4,
    rank: 4,
    title: '科技公司创始人离职内幕，股权变动始末',
    category: 'business',
    heat: '528万',
    trend: 'down',
    tag: '已到结局',
    time: '昨日 18:05',
  },
  {
    id: 5,
    rank: 5,
    title: '社区业主群聊天记录外泄，物业回应争议',
    category: 'society',
    heat: '431万',
    trend: 'up',
    tag: '新瓜速报',
    time: '昨日 15:22',
  },
  {
    id: 6,
    rank: 6,
    title: '老牌歌手复出舞台，十年恩怨再被提起',
    category: 'star',
    heat: '356万',
    trend: 'flat',
    tag: '旧瓜新炒',
    time: '前天 20:44',
  },
];

export const timelineEvents = [
  {
    id: 1,
    category: 'star',
    title: '顶流演员合约纠纷全经过',
    intro: '从一纸解约声明到各方下场表态，我们按时间线把这场持续两个月的风波一次讲透。',
    period: '10月08日 - 12月06日',
    tags: ['起因', '发酵', '多方下场', '结局'],
    stages: [
      { time: '10月08日', label: '起因', text: '工作室深夜发布解约声明，措辞激烈引发第一波讨论。' },
      { time: '10月15日', label: '发酵', text: '多方经纪公司陆续发声，旧合同细节被逐步曝光。' },
      { time: '11月20日', label: '多方下场', text: '资本方与粉丝阵营先后介入，舆情进入白热化。' },
      { time: '12月06日', label: '结局', text: '双方发布联合声明，纠纷以协商方式告一段落。' },
    ],
  },
  {
    id: 2,
    category: 'variety',
    title: '选秀综艺舞台争议始末',
    intro: '一档高分综艺因舞台编排登上热搜，我们从选手立场与节目规则两个角度复盘。',
    period: '09月22日 - 10月14日',
    tags: ['起因', '高潮', '回应', '降温'],
    stages: [
      { time: '09月22日', label: '起因', text: '播出后选手表现引发网友剪辑对比，讨论区迅速升温。' },
      { time: '09月29日', label: '高潮', text: '相关片段登上多平台热搜，阅读量单日破千万。' },
      { time: '10月05日', label: '回应', text: '选手深夜发声，节目组随后说明录制流程。' },
      { time: '10月14日', label: '降温', text: '新一期播出转移焦点，事件热度逐渐回落。' },
    ],
  },
  {
    id: 3,
    category: 'streamer',
    title: '头部主播带货风波全梳理',
    intro: '一场直播中的产品质量争议，为何会牵连整条供应链？我们把因果链捋清楚。',
    period: '11月02日 - 11月28日',
    tags: ['起因', '发酵', '回应', '进展'],
    stages: [
      { time: '11月02日', label: '起因', text: '有消费者反馈收到的商品与介绍不符，晒单引发关注。' },
      { time: '11月09日', label: '发酵', text: '更多同类反馈出现，话题登上平台热榜前列。' },
      { time: '11月16日', label: '回应', text: '团队出面说明品控流程并给出补偿方案。' },
      { time: '11月28日', label: '进展', text: '供应链环节公开回应，事件进入善后阶段。' },
    ],
  },
  {
    id: 4,
    category: 'business',
    title: '科技创始人离职内幕复盘',
    intro: '一纸人事公告背后，公司治理与资本博弈的时间线远比想象中复杂。',
    period: '08月15日 - 10月01日',
    tags: ['起因', '发酵', '关键节点', '结局'],
    stages: [
      { time: '08月15日', label: '起因', text: '公司财报披露管理层调整计划，市场反应谨慎。' },
      { time: '09月03日', label: '发酵', text: '创始人离职消息传开，多方媒体跟进解读股权结构。' },
      { time: '09月18日', label: '关键节点', text: '正式公告发出，董事会席位安排成为讨论焦点。' },
      { time: '10月01日', label: '结局', text: '新管理层亮相并公布下一阶段业务方向，事件告一段落。' },
    ],
  },
  {
    id: 5,
    category: 'society',
    title: '业主群记录外泄事件始末',
    intro: '一份聊天记录的流出，如何在两日内引发一场社区与物业的双向信任危机。',
    period: '07月12日 - 07月28日',
    tags: ['起因', '发酵', '回应', '处理'],
    stages: [
      { time: '07月12日', label: '起因', text: '小区业主群聊天记录被截图外传，内容引发讨论。' },
      { time: '07月17日', label: '发酵', text: '信息传播出小区范围，物业与业主各执一词。' },
      { time: '07月22日', label: '回应', text: '物业发表公开说明，承诺完善信息管理规范。' },
      { time: '07月28日', label: '处理', text: '社区组织多方沟通会，事件逐步走向平息。' },
    ],
  },
  {
    id: 6,
    category: 'star',
    title: '老牌歌手复出背后的十年旧账',
    intro: '一场演唱会官宣，为何把多年前的同行恩怨重新带回大众视野？',
    period: '05月09日 - 06月21日',
    tags: ['起因', '旧闻重现', '回应', '收尾'],
    stages: [
      { time: '05月09日', label: '起因', text: '复出演唱会官宣，票价与场次安排成为关注点。' },
      { time: '05月20日', label: '旧闻重现', text: '多年前的舞台合作争议片段被重新翻出传播。' },
      { time: '06月08日', label: '回应', text: '当事方先后侧面回应，表示尊重过往、专注当下。' },
      { time: '06月21日', label: '收尾', text: '首场演出顺利举办，话题热度随之自然回落。' },
    ],
  },
];

export const reviews = [
  {
    id: 1,
    category: 'star',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20backstage%20of%20a%20concert%20stage%20with%20warm%20amber%20spotlights%20and%20soft%20haze%2C%20silhouette%20of%20microphone%20and%20speaker%2C%20editorial%20magazine%20style%2C%20rich%20coral%20and%20golden%20tones%2C%20no%20faces%2C%20dramatic%20atmosphere&width=1000&height=700&seq=gua-review-1&orientation=landscape',
    title: '顶流合约纠纷：一份声明引发的资本博弈复盘',
    summary: '我们把解约声明、各方回应与资本线索按时间排列，还原整场风波最容易被忽略的推动力。',
    read: '8分钟读完',
    date: '12月09日',
    chapters: ['一份深夜声明', '旧合同浮出水面', '资本与粉丝的博弈', '协商收尾'],
  },
  {
    id: 2,
    category: 'variety',
    cover:
      'https://readdy.ai/api/search-image?query=behind%20the%20scenes%20of%20a%20talent%20variety%20show%20studio%20with%20colorful%20stage%20lights%20and%20camera%20dolly%2C%20editorial%20documentary%20mood%2C%20warm%20lighting%2C%20no%20faces%2C%20creative%20composition&width=1000&height=700&seq=gua-review-2&orientation=landscape',
    title: '舞台争议十日记：一场舆情如何被一帧画面点燃',
    summary: '从一帧被反复剪辑的舞台画面出发，复盘舆情从酝酿、引爆到降温的完整周期。',
    read: '6分钟读完',
    date: '12月06日',
    chapters: ['引爆画面', '规则之争', '当事人的深夜回应', '热度自然消退'],
  },
  {
    id: 3,
    category: 'society',
    cover:
      'https://readdy.ai/api/search-image?query=urban%20community%20street%20at%20dusk%20with%20warm%20streetlights%20and%20residential%20buildings%2C%20editorial%20photography%2C%20soft%20warm%20tones%2C%20no%20faces%2C%20thoughtful%20atmosphere&width=1000&height=700&seq=gua-review-3&orientation=landscape',
    title: '一份群聊记录，为何能搅动一座小区？',
    summary: '信息外泄只是表象，真正值得复盘的是私域信息在舆论场的传播路径与边界。',
    read: '7分钟读完',
    date: '12月02日',
    chapters: ['外泄的24小时', '物业的回应话术', '信息边界的思考', '社区沟通的解法'],
  },
];

export const hotTopics = [
  { key: 'star', name: '明星娱乐', count: 128, icon: 'ri-star-smile-fill', desc: '剧集、演唱会与行业动态的瓜都在这里。' },
  { key: 'variety', name: '综艺现场', count: 96, icon: 'ri-camera-fill', desc: '录制花絮、赛制争议与舞台名场面。' },
  { key: 'business', name: '商业财经', count: 74, icon: 'ri-line-chart-fill', desc: '公司人事、资本动向与行业变局复盘。' },
  { key: 'society', name: '社会民生', count: 61, icon: 'ri-earth-fill', desc: '公共议题与民生热点的事件脉络整理。' },
  { key: 'streamer', name: '直播网红', count: 52, icon: 'ri-live-fill', desc: '直播间风波、人设翻转与流量生态观察。' },
];

export const quickNews = [
  { id: 1, time: '今天 08:40', tag: '新瓜速报', title: '某新剧首播收视走高，原著粉与剧粉吵上热搜', category: 'variety' },
  { id: 2, time: '今天 07:15', tag: '持续发酵', title: '带货团队回应品控质疑，公布抽查批次结果', category: 'streamer' },
  { id: 3, time: '昨天 23:02', tag: '旧瓜新炒', title: '十年老采访又被翻出，当事人一句话引发重读潮', category: 'star' },
  { id: 4, time: '昨天 20:11', tag: '官方回应', title: '涉事企业就招标争议发布说明，接受监督', category: 'business' },
  { id: 5, time: '昨天 16:47', tag: '事件进展', title: '物业新增业主恳谈会，承诺公开处理流程', category: 'society' },
  { id: 6, time: '昨天 12:30', tag: '新瓜速报', title: '导演直播谈选角标准，无意提到某演员引猜测', category: 'variety' },
];

export const faqs = [
  {
    q: '什么是"事件时间线"？',
    a: '事件时间线是我们把某个热点事件的起因、发酵、关键节点与结局，按发生时间顺序整理成的一条清晰脉络。相比碎片化刷帖，时间线能帮你快速建立完整背景，避免只看到事件中途的片段而误读全貌。',
  },
  {
    q: '"全经过复盘"和普通新闻报道有什么区别？',
    a: '普通报道通常聚焦当下时点，而全经过复盘会回看整个事件的起承转合，把被忽略的细节、各方回应的时间差以及事件演变的内在逻辑一并梳理，让你一次补完全部背景。',
  },
  {
    q: '你们的信息来源可靠吗？如何核实？',
    a: '我们以公开可查的官方声明、当事人公开发言与权威媒体报道为素材来源，复盘时严格标注事件发生时间，不传播未经证实的私密信息，并在事件出现反转时及时更新脉络。',
  },
  {
    q: '为什么我看到的复盘"结局"可能还会变？',
    a: '很多热点事件是动态发展的，我们所标记的"结局"指的是当前可公开确认的阶段结果。若后续出现新进展或反转，我们会第一时间更新时间线与复盘文章，建议你关注该事件的最新更新。',
  },
  {
    q: '我看到某条内容和你复盘的不一样，怎么反馈？',
    a: '如果你掌握更准确或更新的信息，欢迎通过页脚联系方式告诉我们。编辑部会核实后修正相关时间线与细节，确保复盘内容尽量准确、客观。',
  },
  {
    q: '你们的复盘立场客观吗？会不会偏袒某一方？',
    a: '我们坚持"摆时间线、讲公开事实"的原则，尽量让各方声音都有呈现，不替任何一方下结论。复杂事件中不同立场都有合理之处，我们的职责是帮你看见全貌，而非代替你判断。',
  },
];